// MySnackbar.tsx
import React from 'react';
import { styled } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import Alert from './Alert';

// Custom styled Snackbar with margin
const CustomSnackbar = styled(Snackbar)(({ theme }) => ({
	margin: theme.spacing(1),
}));

export interface MySnackbarProps {
	open: boolean;
	message: string;
	severity?: 'error' | 'warning' | 'info' | 'success';
	onClose?: () => void;
	position?: {
		vertical: 'top' | 'bottom';
		horizontal: 'left' | 'center' | 'right';
	};
}

export const MySnackbar: React.FC<MySnackbarProps> = ({
	open,
	message,
	severity = 'info',
	onClose,
	position = { vertical: 'bottom', horizontal: 'left' },
}) => (
	<CustomSnackbar open={open} autoHideDuration={2000} onClose={onClose} anchorOrigin={position}>
		<Alert
			onClose={onClose}
			severity={severity}
			sx={{
				width: '100%',
				// optional: safe boxShadow
				// boxShadow: 3, // uses theme.shadows[3], avoids parsing rgba error
			}}
		>
			{message}
		</Alert>
	</CustomSnackbar>
);

export default MySnackbar;
